var React = require('react');

function MobileClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"6.21875","y":"4.80762","width":"24","height":"2","transform":"rotate(45 6.21875 4.80762)","key":0}),React.createElement("rect",{"x":"4.8125","y":"21.7783","width":"24","height":"2","transform":"rotate(-45 4.8125 21.7783)","key":1})]);
}

MobileClose.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = MobileClose;

MobileClose.default = MobileClose;
